import { render } from "./SubmissionStatus.vue?vue&type=template&id=aac16a60&ts=true"
import script from "./SubmissionStatus.vue?vue&type=script&lang=ts"
export * from "./SubmissionStatus.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__